import React from 'react';
import axios from "../../containers/api";
import {Alert, Button, FormGroup, Input, Label, Modal, ModalBody, ModalHeader} from "reactstrap";
import {showCatchError, toEnglishNumbers} from "../../helpers/Utils";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import NewUserModal from "./NewUserModal";

class NewTransportationCompany extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModal: this.props && this.props.isModal,
            ProvinceList: [],
            TransportationCompanyName: "",
            Email: "",
            NationalId: "",
            Address: "",
            PostalCode: "",
            Tell: "",
            Mobile: "",
            Province: null,
            CityList: [],
            City: null,
            showNewMemberModal: false,
            newMemberUsername: null,
            newMemberPassword: null,
            errors: []
        }
    }

    componentDidMount() {
        //if (!this.state.isModal) {
        //   // this.CheckMemberTypeIsAdmin();
        //   this.loadProvinces();
        //}
    }

    //componentWillReceiveProps(nextProps) {
    //    if (this.props !== nextProps) {
    //        this.setState({ProvinceList: this.props.ProvinceList});
    //    }
    //}
    componentWillMount() {
        this.loadProvinces();
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data) {
                    this.loadProvinces();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    loadProvinces = () => {
        this.props.showSpinner();
        axios.get('api/v1/Province/GetAll')
            .then((res) => {
                this.props.hideSpinner();
                this.setState({ProvinceList: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    loadCities = (id) => {
        this.props.showSpinner();
        axios.get('api/v1/City/GetCityByProvinceId?provinceId=' + id)
            .then((res) => {
                this.props.hideSpinner();
                this.setState({CityList: res.data.data});
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.TransportationCompanyName.length ===0) {
            error.push("وارد كردن نام  الزامی میباشد");
        }
        if (this.state.NationalId.length < 10 ) {
            error.push("کد ملی نباید کمتر از ۱۰ حرف باشد.");
        }
        if (this.state.Mobile.length === 0) {
            error.push("وارد كردن تلفن يا موبايل الزامی میباشد.");
        }
       
        if (this.state.City === null || this.state.City === undefined) {
            error.push("انتخاب شهر الزامی میباشد.");
        }

        this.setState({errors: error});
        if (error.length === 0) {
            this.AddTransportationCompany();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };

    AddTransportationCompany= () => {
        const addModel = {
            TransportationCompanyName: toEnglishNumbers(this.state.TransportationCompanyName),
            Email: toEnglishNumbers(this.state.Email),
            NationalId: toEnglishNumbers(this.state.NationalId),
            Address: toEnglishNumbers(this.state.Address),
            PostalCode: toEnglishNumbers(this.state.PostalCode),
            Tell: toEnglishNumbers(this.state.Tell),
            Mobile: toEnglishNumbers(this.state.Mobile),
            CityId: this.state.City !== null ? this.state.City.cityId : null
        };

        this.props.showSpinner();
        axios.post('api/v1/TransportationCompany/AddTransportationCompany', addModel)
            .then((res) => {
                this.props.hideSpinner();
                if (res.status === 200) {
                    this.setState({
                        newMemberUsername: res.data.data.userName,
                        newMemberPassword: res.data.data.password,
                        showNewMemberModal: true
                    });
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    
    selectHandleChange = (event, value, name) => {
        this.setState({ [name]: value },
            () => {
                if (name === "Province") {
                    if (value !== undefined && value !== null) {
                        this.setState({
                            City: null
                        }, () => this.loadCities(value.provinceId));
                    }
                    else {
                        this.setState({
                            City: null, CityList: []
                        })
                    }
                }

            });
    };
    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>نام صاحب کالا</Label>
                        <Input value={this.state.TransportationCompanyName} maxLength={300}
                               onChange={(e) => this.setState({ TransportationCompanyName: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>موبایل</Label>
                        <Input value={this.state.Mobile} maxLength={11}
                               onChange={(e) => this.setState({ Mobile: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>کد ملی</Label>
                        <Input value={this.state.NationalId} maxLength={11}
                               onChange={(e) => this.setState({ NationalId: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>آدرس</Label>
                        <Input value={this.state.Address}
                               onChange={(e) => this.setState({ Address: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>کد پستی</Label>
                        <Input value={this.state.PostalCode} maxLength={10}
                               onChange={(e) => this.setState({ PostalCode: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>تلفن</Label>
                        <Input value={this.state.Tell} maxLength={100}
                               onChange={(e) => this.setState({ Tell: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>ایمیل</Label>
                        <Input value={this.state.Email} maxLength={100}
                               onChange={(e) => this.setState({ Email: e.target.value })}/>
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>استان</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="Province"
                            options={this.state.ProvinceList}
                            getOptionLabel={(option) => option.provinceName}
                            value={this.state.Province}
                            onChange={(e, v) => this.selectHandleChange(e, v, "Province")}
                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-30 w-100 px-1">
                        <Label>شهر</Label>
                        <Autocomplete
                            clearText={"حذف"}
                            closeText={"بستن"}
                            noOptionsText={"در حال دریافت اطلاعات.."}
                            openText={"باز کردن"}
                            className="react-select__control"
                            id="City"
                            options={this.state.CityList}
                            getOptionLabel={(option) => option.cityName}
                            value={this.state.City}
                            onChange={(e, v) => this.selectHandleChange(e, v, "City")}
                            renderInput={(params) => (<TextField{...params} variant="standard"/>)}
                        />
                    </FormGroup>
                </div>

                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center align-items-end flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2"
                                onClick={() => this.props.showSweetAlert("آیا از صحت اطلاعات وارد شده اطمینان دارید؟", "", "warning", this.validateInputData)}>
                            ثبت
                        </Button>
                    </FormGroup>
                </div>

                <Modal isOpen={this.state.showNewMemberModal} toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                    <ModalHeader toggle={() => this.setState({showNewMemberModal: false, newMemberUsername: null, newMemberPassword: null})}>
                        اطلاعات کاربری
                    </ModalHeader>
                    <ModalBody>
                        <NewUserModal
                            newMemberUsername={this.state.newMemberUsername}
                            newMemberPassword={this.state.newMemberPassword}
                        />
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

export default NewTransportationCompany;